import React from 'react';
import * as S from './style';

// NOTE: To make sure it toggles give a prop called selected
// and change to either 'right' or 'left' depending on what's the opposite
// to what's currently been highlight on the last click

const Toggle = ({
  leftText,
  rightText,
  midText,
  style,
  onClick,
  outline,
  ...props
}) => {
  return (
    <S.ToggleWrapper {...props} style={style} outline={outline}>
      <S.Left onClick={() => onClick('left')} outline={outline} {...props}>
        {leftText}
      </S.Left>
      {midText && (
        <S.Middle
          onClick={() => onClick('middle')}
          outline={outline}
          {...props}
        >
          {midText}
        </S.Middle>
      )}
      <S.Right onClick={() => onClick('right')} outline={outline} {...props}>
        {rightText}
      </S.Right>
    </S.ToggleWrapper>
  );
};

export default Toggle;
